import { OASMetadata } from './metadata/metadata';

export default OASMetadata;
